import { Redirect, Route, Switch } from 'react-router-dom';

import { Container, Footer, NavBar, Wrapper } from '../Common/Layout';
import { Routes } from '../Common/useNavigation';
import { useParticipant } from './ParticipantProvider';
import CharityPage from './Registrations/Charity/CharityPage';
import Guard from './Guard';
import MailPreferencesPage from './MailPreferences/MailPreferencesPage';
import OrderPage from './Registrations/Orders/OrderPage';
import OrdersPage from './Registrations/Orders/OrdersPage';
import RegistrationsPage from './Registrations/RegistrationsPage';
import UI from '../../common/UI';
import UpgradesPage from './Registrations/Upgrades/UpgradesPage';
import useAtletaEmbed from '../../common/useAtletaEmbed';
import useProject from '../useProject';

interface DashboardProps {
  participantId: string;
}

const Dashboard = ({ participantId }: DashboardProps) => {
  const { participant, impersonating } = useParticipant();
  const project = useProject();

  useAtletaEmbed();

  const impersonatedUsername = impersonating ? participant?.first_name : null;

  return (
    <Wrapper>
      <NavBar impersonatedUsername={impersonatedUsername} />

      <Container>
        {!project && (
          <UI.PageLoader />
        )}

        {project && (
          <Guard
            scopedParticipant={{ id: participantId }}
            sc={{ textAlign: 'center' }}
          >
            <Switch>
              <Route
                path={Routes.Upgrades}
                render={({ match: { params: { participantId, eventId, token } } }) => (
                  <UpgradesPage
                    participantId={participantId}
                    eventId={eventId}
                    token={token}
                  />
                )}
              />

              <Route
                path={Routes.MailPreferences}
                render={({ match: { params: { participantId } } }) => (
                  <MailPreferencesPage participantId={participantId} />
                )}
              />

              <Route
                path={Routes.Order}
                render={({ match: { params: { participantId, eventId, orderId, token } } }) => (
                  <OrderPage
                    participantId={participantId}
                    eventId={eventId}
                    orderId={orderId}
                    token={token}
                  />
                )}
              />

              <Route
                path={Routes.Orders}
                render={({ match: { params: { participantId, eventId, token } } }) => (
                  <OrdersPage
                    participantId={participantId}
                    eventId={eventId}
                    token={token}
                  />
                )}
              />

              <Route
                path={Routes.Charity}
                render={({ match: { params: { participantId, eventId, token } } }) => (
                  <CharityPage
                    participantId={participantId}
                    eventId={eventId}
                    token={token}
                  />
                )}
              />

              <Route
                path={Routes.Registrations}
                render={({ match: { params: { participantId, eventId, token } } }) => (
                  <RegistrationsPage
                    participantId={participantId}
                    eventId={eventId}
                    token={token}
                  />
                )}
              />

              <Redirect to={Routes.Portal} />
            </Switch>
          </Guard>
        )}

        <Footer project={project} participant={participant} />
      </Container>
    </Wrapper>
  );
};

export default Dashboard;
